module.exports = __webpack_public_path__ + "img/knu2_gallery12.e63d8232.jpg";